/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function o(e, r, n) {
  return e ? r(e) : n == null ? void 0 : n(e);
}
export {
  o as when
};
